var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-group-input',{class:{ error: _vm.error },attrs:{"optgroups":_vm.optionGroups,"options":_vm._options,"selected":_vm.selected},on:{"change":function($event){_vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }